import { inject, Injectable } from '@angular/core';
import { ODataQueryOptions } from '../../../models/shared/odata-query-options';
import { MembersDomainModel } from '../../../domainModels/members-domain-model';
import { tap } from 'rxjs/operators';
import { SessionService } from '../../../services/session-service';
import { MemberSubmissionHistoryService } from '../components/user-profiles/member-user-profile/services/member-submission-history.service';

@Injectable()
export class MpProfilePostSubmissionRefreshService {
  private membersDomainModel = inject(MembersDomainModel);
  private sessionService = inject(SessionService);
  private submissionHistoryService = inject(MemberSubmissionHistoryService);

  public refreshAfterSubmission() {
    const opts = new ODataQueryOptions();
    opts.setExpand(
      'Address($expand=State, Country), EmploymentHistory($expand=EmploymentStatus), Gender, Pronoun, RelationshipStatus($expand=Type, Spouse($expand=Address($expand=State, Country)))'
    );
    return this.membersDomainModel.memberPortalGetMember(opts).pipe(
      tap(member => {
        this.sessionService.updateUser(member);
        this.submissionHistoryService.refetchSubmissionHistory();
      })
    );
  }
}
